import React, { useContext } from "react";
import { DownOutlined, UserOutlined } from '@ant-design/icons';
import { Button, Dropdown, message, Space, Tooltip } from 'antd';
import { PaymentContext } from "../../../common/PaymentContext";

const DropCountry = (props) => {
    const { paymentMethods, setPaymentMethods } = useContext(PaymentContext);
    let items = [];

    const handleMenuClick = (e) => {
        message.success('Méthode de paiement ajoutée.');
        setPaymentMethods([e.key]);
    };

    props.paymentMethods.map((item, i) => {
        let idKey = String(i);
        if (item.status == 'ACTIVE') {
            items.push({
                label: item.name,
                key: item.id
            })
        } else {
            items.push({
                label: item.name,
                key: item.id,
                disabled: true
            })
        }



    })

    const menuProps = {
        items,
        onClick: handleMenuClick
    }

    const returnDropdown = () => {
        if (props.countryName == props.selectedCountry) {
            return (
                <Dropdown menu={menuProps} >
                    <Button className="w-100">
                        <Space>
                            {props.countryName}
                            <DownOutlined />
                        </Space>
                    </Button>
                </Dropdown>
            )
        } else {
            return (
                <Dropdown menu={menuProps} disabled>
                    <Button className="w-100">
                        <Space>
                            {props.countryName}
                            <DownOutlined />
                        </Space>
                    </Button>
                </Dropdown>)
        }
    }
    
    return (
       <>
        {returnDropdown()}
       </>
    )
}

export default DropCountry;